/**
 * @file 重定向url 主要用于自动跳转h5链接
 */
// eslint-disable-next-line
// @ts-nocheck

import {
  supportLang,
  getLanguage,
  replacePath,
  getOriginPath
} from '@/lang/i18n';
import { langs } from '@/config/setup';
import { isApp, isPC } from '@/utils/tools';
import { h5Host } from '@/config/setup';
// 路径参数替换方法
const replaceParamsInPath = (path: string, params: Record<string, string>) => {
  return path.replace(/\{([^}]+)\}/g, (_, key) => params[key] || '');
};
// 路由跳转方法
const createRedirect = (basePath: string, path: string, query: Record<string, string>, hash: string) => {
  const finalPath =  basePath && supportLang(basePath) ? `/${basePath}/${path}` : `/${path}`;
  return { path: finalPath, replace: false, query, hash };
};

export default [
  ({ path, hash, meta, params, query }: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {

    const pathLang = path.split('/')[1];
    let { h5: h5Path } = meta;
    const { mobilePath, pcPath } = meta;
    if (h5Path && (isApp() || !isPC())) {
      if (!supportLang(pathLang) && langs.length > 1) {
        const defaultLang = getLanguage();
        // 正常h5、pc用相同的path，兼容不相同的情况
        h5Path = replacePath(h5Path, defaultLang);
      }

      if (!h5Path.includes(pathLang)) {
        h5Path = `/${pathLang === 'fa' ? 'fa-IR' : pathLang}/${h5Path}`;
      }

      const paramsKeys = Object.keys(params);
      if (paramsKeys.length) {
        paramsKeys.forEach(key => {
          if (h5Path.includes(key)) {
            h5Path = h5Path.replace(`:${key}`, params[key]);
          }
        });
      }

      if (!import.meta.env.SSR) {
        const h5URL = `${h5Host}${h5Path}${window.location.search}${hash}`;
        window.location.href = h5URL;
      }
    }

    // 统一处理移动端和PC端路由
    if (mobilePath && !isPC()) {
      const replacedPath = replaceParamsInPath(mobilePath, params);

      console.log('replacedPath', replacedPath);

      next(createRedirect(pathLang, replacedPath, query, hash));
    }

    if (pcPath && isPC()) {
      const replacedPath = replaceParamsInPath(pcPath, params);
      next(createRedirect(pathLang, replacedPath, query, hash));
    }

    // h5注册页面 增加记录来源path
    if (getOriginPath(path) === '/register/invite' && from.path != '/') {
      sessionStorage.setItem('register_from', from.path);
    }

    // 浏览器环境
    if (!import.meta.env.SSR) {
      const { responsive } = meta;
      const pathLang = path.split('/')[1];

      if (typeof responsive === 'function') {
        const responsiveData = responsive(path, meta, params, query, hash);

        if (responsiveData) {
          return next({
            meta,
            params,
            query,
            hash,
            ...responsiveData,
            path: supportLang(pathLang) ? `/${pathLang}${responsiveData.path}` : responsiveData.path,
            replace: false
          });
        }
      }

      // 响应式页面跳转
      if (responsive?.redirectType === 'route') {
        if ((responsive.pageType === 'web' && isPC()) || (responsive.pageType === 'h5' && !isPC())) {
          return next({
            path: supportLang(pathLang) ? `/${pathLang}${responsive.path}` : responsive.path,
            replace: false,
            params,
            query,
            hash
          });
        }
      }

      // 注册页加人机验证需求，必须是页面跳转
      if (getOriginPath(path) === '/register' && localStorage.getItem('register_refresh') !== 'true') {
        // 记录注册来源
        if (from.path != '/') {
          sessionStorage.setItem('register_from', from.path);
        }
        let search = '';
        Object.keys(query).forEach((key: string) => {
          search = search ? `${search}&${key}=${query[key]}` : `?${key}=${query[key]}`;
        });
        localStorage.setItem('register_refresh', 'true');
        window.location.href = `${window.location.origin}/register${search}`;
        return;
      } else if (getOriginPath(path) !== '/register') {
        localStorage.setItem('register_refresh', 'false');
      }
    }

    next();
  }
];
